const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate jsonParseBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  return JSON.parse(value);
};
module.exports = {
  evaluate
};